module.exports = {
    acesso: 'Acesso',
    acessoMoodle: 'Acesso Moodle',
    administradores: 'Administradores',
    administradoresDisponiveis: 'Administradores disponíveis',
    administradoresVinculados: 'Administradores vinculados',
    acessoPacs: 'Acesso PACS',
    habilitadoAcessoMoodle: 'Habilitado acesso ao Moodle',
    habilitadoAcessoPacs: 'Habilitado acesso ao PACS',
    ipCadastrado: 'IP cadastrado',
    nivelPermissaoCadastrado: 'Nível de permissão cadastrado',
    alterarSenha: 'Alterar senha',
    cadastrarCredencial: 'Cadastrar credencial',
    cadastrarParceiro: 'Cadastrar parceiro',
    caminhoPath: 'Caminho (Path)',
    console: 'Console',
    credencialCadastradaSucesso: 'Credencial cadastrada com sucesso.',
    credencialAtualizadaSucesso: 'Credencial atualizada com sucesso.',
    credenciais: 'Credenciais',
    parceiros: 'Parceiros',
    parceiroCadastradoSucesso: 'Parceiro cadastrado com sucesso.',
    parceiroAtualizadoSucesso: 'Parceiro atualizado com sucesso.',
    dataAtualizacao: 'Data de atualização',
    dataCriacao: 'Data de criação',
    dnsFormatoInvalido: 'Informe "*" ou um domínio completo válido (ex.: api.telemedicina.ufsc.br).',
    dnsWildcards: 'DNS (Wildcards permitidos)',
    editarCredencial: 'Editar credencial',
    editarParceiro: 'Editar parceiro',
    editarEtapas: 'Editar etapas',
    email: 'E-mail',
    emailResponsavel: 'E-mail do responsável técnico',
    erroSalvarCredencial: 'Não foi possível salvar a credencial.',
    erroListarParceiros: 'Não foi possível listar os parceiros.',
    erroSalvarParceiro: 'Não foi possível salvar o parceiro.',
    enviarImagem: 'Enviar imagem',
    tipoArquivoInvalido: 'Tipos permitidos: PNG, JPEG, WebP e SVG.',
    arquivoMuitoGrande: 'Tamanho máximo: 2 MB.',
    estados: 'Estados',
    formulário: 'Formulário',
    json: 'JSON',
    jsonInvalido: 'JSON inválido. Corrija a sintaxe antes de salvar.',
    formatar: 'Formatar',
    estadosVinculo: 'Selecione os estados de vínculo',
    gerarSenha: 'Gerar senha',
    gestaoModulos: 'Gestão de Módulos',
    gestaoCredenciais: 'Gestão de Credenciais',
    gestaoParceiros: 'Gestão de Parceiros',
    cadastrarModulo: 'Cadastrar módulo',
    editarModulo: 'Editar módulo',
    moduloCadastradoSucesso: 'Módulo cadastrado com sucesso.',
    moduloAtualizadoSucesso: 'Módulo atualizado com sucesso.',
    erroListarModulos: 'Não foi possível listar os módulos.',
    erroSalvarModulo: 'Não foi possível salvar o módulo.',
    siglaModulo: 'Sigla do módulo',
    siglaJaExiste: 'Esta sigla já está em uso.',
    siglaFormatoInvalido: 'Informe uma sigla válida (apenas letras maiúsculas, números e underscore).',
    configuracao: 'Configuração',
    habilitar: 'Habilitar',
    informacoesGerais: 'Informações gerais',
    instituicaoUnidade: 'Instituição/Unidade',
    confirmarRemocaoItem: 'Deseja realmente remover este item?',
    ipFormatoInvalido: 'Informe um IP válido no formato CIDR (ex.: 192.168.0.0/24).',
    intervalosIpCidr: 'Insira os intervalos de IP permitidos no formato CIDR',
    intervaloIp: 'Intervalo de IP (no formato CIDR)',
    ip: 'IP',
    login: 'Login',
    loginJaExiste: 'Este login já está em uso.',
    loginNome: 'Login ou nome',
    nivelPermissao: 'Nível de Permissão',
    nivelPermissaoEndpoint: 'Nível de permissão e endpoint',
    nome: 'Nome',
    nomeResponsavel: 'Nome do responsável técnico',
    pathFormatoInvalido: 'Informe um path válido (ex.: /administrativo).',
    seguranca: 'Segurança',
    segurançaIP: 'Segurança de IP',
    senhaCaracteresInvalidos: 'A senha deve conter apenas letras e números.',
    senhaTamanhoMinimo: 'A senha deve ter no mínimo 32 caracteres.',
    situacao: 'Situação',
    todos: 'Todos',
    urlParceiro: 'URL do parceiro',
    urlJaExiste: 'Esta URL já está em uso.',
    urlFormatoInvalido: 'Informe uma URL válida (apenas letras, números e underscore).',
    // Validação de formulários RJSF (Yup)
    campoObrigatorio: 'Campo obrigatório',
    campoInvalido: 'Inválido',
    emailInvalido: 'E-mail inválido',
    urlInvalida: 'URL inválida',
    erroMaxCaracteres: (maxCaracteres, nomeCampo) => `O campo ${nomeCampo} deve ter no máximo ${maxCaracteres} caractéres.`,
    erroMinCaracteres: (minCaracteres, nomeCampo) => `O campo ${nomeCampo} deve ter no mínimo ${minCaracteres} caractéres.`,
    valorMinimo: (min) => `Deve ser maior ou igual a ${min}`,
    valorMaximo: (max) => `Deve ser menor ou igual a ${max}`,
    numeroInvalido: 'Número inválido',
    inteiroInvalido: 'Informe um número inteiro válido',
};